import jsPsychAudioButtonResponse from '@jspsych/plugin-audio-button-response';
import store from 'store2';
import { mediaAssets } from '../helperFunctions';

export const audio_feedback = {
  type: jsPsychAudioButtonResponse,
  stimulus: () => {
    if (store.session.get('config').audioFeedback === 'binary' && store.session('currentTrialCorrect')) {
      return mediaAssets.audio.success;
    }
    if (store.session.get('config').audioFeedback === 'binary' && !store.session('currentTrialCorrect')) {
      return mediaAssets.audio.fail;
    }
    // neutral case
    return mediaAssets.audio.select;
  },
  choices: [],
  trial_ends_after_audio: true,
};
